import { useEffect } from 'react'
import { Modal } from 'medere-ui-framework'
import { StockItemTypeContractListItemDTO } from '../../../dto/stockItemTypeContract/StockItemTypeContractDTO'
import { formatIsoDate, formatPercentage } from '../stockItemTypeContractFormat'

interface DeactivateStockItemTypeContractModalProps {
  visible: boolean
  contract: StockItemTypeContractListItemDTO | null
  confirming: boolean
  onCancel: () => void
  onConfirm: () => void
}

function describeValidity(contract: StockItemTypeContractListItemDTO): string {
  if (!contract.validuntil) return `vigente desde el ${formatIsoDate(contract.validfrom)}, sin fecha de fin`
  return `vigente del ${formatIsoDate(contract.validfrom)} al ${formatIsoDate(contract.validuntil)}`
}

/** Modal de decisión (§3.8.3): la consecuencia en el texto y el foco inicial en la opción segura. */
export default function DeactivateStockItemTypeContractModal({
  visible,
  contract,
  confirming,
  onCancel,
  onConfirm,
}: Readonly<DeactivateStockItemTypeContractModalProps>) {
  // El Modal del framework no expone el foco inicial: se lleva a "Cancelar" al abrir.
  useEffect(() => {
    if (!visible) return
    const timer = window.setTimeout(() => {
      const cancelButton = document.querySelector('.stc-deactivate-modal .modalFooter .buttonMain3')
      if (cancelButton instanceof HTMLElement) cancelButton.focus()
    }, 50)
    return () => window.clearTimeout(timer)
  }, [visible])

  return (
    <Modal
      visible={visible}
      setVisible={(nextVisible) => {
        if (!nextVisible) onCancel()
      }}
      header={<span className='stc-modal-title'>¿Desactivar contrato?</span>}
      width='w-medium'
      className='stc-modal stc-deactivate-modal'
      footerButtonLeftText='Cancelar'
      onClickLeftBtn={onCancel}
      footerButtonRightText='Desactivar'
      onClickRightBtn={onConfirm}
      rightButtonDisabled={confirming}
    >
      {contract && (
        <p className='stc-confirm-text'>
          Se va a desactivar el contrato de <strong>{contract.healthentityname}</strong>{' '}
          ({contract.healthentityplanname}, {contract.stockitemtypedesc}, {contract.contractattentionmodalitydesc}) con{' '}
          {formatPercentage(contract.percentage)} de cobertura, {describeValidity(contract)}.
          Deja de aplicarse desde ahora y no se puede volver a activar.
        </p>
      )}
    </Modal>
  )
}
